import { Modal as AntModal, Popconfirm } from "antd"
import { XMarkIcon } from "@heroicons/react/24/outline"
import * as React from "react"
import { Button } from "../../Button/Button"
import { AntdIconWrap } from "../../Icons/AntdIconWrap"

type Props = {
    src: string // base64 or url
    isOpen: boolean
    onClose: () => void
    onRemove: () => void
}

export const ImageModal = (props: Props) => {
    return (
        <AntModal
            destroyOnClose={true}
            closable={false}
            footer={null}
            title={null}
            onCancel={props.onClose}
            visible={props.isOpen}
            className={classes.modal}>
            <button onClick={() => props.onClose && props.onClose()} type="button" className={classes.closeIconWrap}>
                <XMarkIcon className={classes.closeIcon} />
            </button>
            <img alt="Image preview" src={props.src} className={classes.img} />
            <div className={classes.btnsWrap1}>
                <div className={classes.btnsWrap2}>
                    <Popconfirm
                        title="Do you really want to remove the image?"
                        onConfirm={props.onRemove}
                        okText="Yes"
                        cancelText="No">
                        <Button type="danger" className={classes.actionBtn}>
                            <AntdIconWrap type="delete" />
                            Remove
                        </Button>
                    </Popconfirm>
                    <Button className={classes.actionBtn} onClick={props.onClose}>
                        Close
                    </Button>
                </div>
            </div>
        </AntModal>
    )
}

const classes = {
    modal: "w-full max-w-xl [&_.ant-modal-content]:p-3",
    img: "block h-auto w-full border border-solid border-gray-200",
    closeIconWrap: "absolute -right-1 -top-1 block cursor-pointer bg-transparent p-3",
    closeIcon: "h-auto w-[22px] opacity-50 hover:opacity-100",
    btnsWrap1: "flex justify-end -mb-3 mt-4",
    btnsWrap2: "flex w-full max-w-[240px] space-x-2",
    actionBtn: "flex-1",
}
